export default __webpack_public_path__ + "static/media/icon-email-marketing-all-times.acc0b0cf.svg";